import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { timeModel } from '~/models';
import { LineItemPendingApprovalReason } from '~/types/api.model';
import { utils } from '~/utils';
import styles from './ScheduledInvoice.module.scss';
export const scheduledInvoiceColumnsTextsPath = 'pages.agreementMinisite.scheduledInvoice.columns';
export function getColumnDefs(texts) {
    return [
        {
            width: 330,
            value: texts.serviceName()
        },
        {
            width: [
                53,
                90
            ],
            hAlign: 'end',
            value: texts.quantity()
        },
        {
            width: [
                90,
                120
            ],
            hAlign: 'end',
            value: texts.rate()
        },
        {
            width: [
                70,
                90
            ],
            hAlign: 'end',
            value: texts.discount()
        },
        {
            width: [
                80,
                104
            ],
            hAlign: 'end',
            value: texts.total()
        },
        {
            width: 130,
            value: texts.status()
        },
        {
            width: 96,
            value: ''
        }
    ];
}
export const HeaderDateIndicator = (param)=>{
    let { label, date, testId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.headerDateIndicator,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                children: label
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                testId: testId,
                children: timeModel.formatDateLong(date)
            })
        ]
    });
};
export const makeTestId = (chargeId)=>"scheduled-invoice-row-".concat(chargeId);
export function displayLineItemRate(rate) {
    return !rate || rate.amount.isZero() ? '' : rate.unit ? "".concat(utils.formatDollarAmount(rate.amount), "/").concat(rate.unit) : utils.formatDollarAmount(rate.amount);
}
export const pendingApprovalReasonsClientTextsPath = 'pages.agreementMinisite.scheduledInvoice.pendingApprovalReasons.client';
export const pendingApprovalReasonsVendorTextsPath = 'pages.agreementMinisite.scheduledInvoice.pendingApprovalReasons.vendor';
export function getClientStatusTooltip(pendingApprovalReason, texts) {
    switch(pendingApprovalReason){
        case LineItemPendingApprovalReason.AdHocCharge:
            return texts.adHocCharge();
        case LineItemPendingApprovalReason.ServiceAmendment:
            return texts.serviceAmendment();
        case LineItemPendingApprovalReason.VariableExceedsCap:
            return texts.variableExceedsCap();
        case LineItemPendingApprovalReason.VariableZeroCap:
            return texts.variableZeroCap();
        case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
            return texts.rangeExceedsMaxPrice();
        case LineItemPendingApprovalReason.VariableCumulative:
            return texts.variableCumulative();
        case LineItemPendingApprovalReason.NonVariableCumulative:
        case LineItemPendingApprovalReason.OverlappingPeriod:
            return texts.nonVariableCumulative();
    }
}
export function getVendorStatusTooltip(pendingApprovalReason, texts) {
    switch(pendingApprovalReason){
        case LineItemPendingApprovalReason.AdHocCharge:
            return texts.adHocCharge();
        case LineItemPendingApprovalReason.ServiceAmendment:
            return texts.serviceAmendment();
        case LineItemPendingApprovalReason.VariableExceedsCap:
            return texts.variableExceedsCap();
        case LineItemPendingApprovalReason.VariableZeroCap:
            return texts.variableZeroCap();
        case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
            return texts.rangeExceedsMaxPrice();
        case LineItemPendingApprovalReason.VariableCumulative:
            return texts.variableCumulative();
        case LineItemPendingApprovalReason.NonVariableCumulative:
        case LineItemPendingApprovalReason.OverlappingPeriod:
            return texts.nonVariableCumulative();
    }
}
